export enum STEPS {
  SITE_URL = 'site-url',
  INSTALLATION_METHOD = 'installation-method',
  MANUAL_INSTALLATION = 'manual-install',
  INVITE_TEAMMATE = 'invite-teammate',
  NPM = 'npm',
  GTM = 'gtm',
  CMS = 'cms',
  PLATFORMS = 'platforms',
  SHARE_TRACKING_CODE = 'share-tracking-code',
  MOBILE_LOCK = 'mobile-lock',
}
